import { render, staticRenderFns } from "./KeywordConfig.vue?vue&type=template&id=7799cda1&scoped=true"
import script from "./KeywordConfig.vue?vue&type=script&lang=js"
export * from "./KeywordConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7799cda1",
  null
  
)

export default component.exports